/**
 * aixos http配置
 */
import axios from 'axios'
import {browserHistory} from 'react-router';
import {sjsyApi,studentLoginUrlWithSchoolCode, parentsLoginUrl} from 'constant/constant.js';
import {getLocalData, getUrlParam, isParentPage, isParentDomain} from 'utils/util';

window.baseUrl = '';
const timer = null;
const NODE_ENV = process.env.NODE_ENV;
window._rap_ = (process.env.BUILD_TEST || NODE_ENV === 'development') ? 'http://api.t.shijieu.cn/' : 'https://api.shijieu.cn/';
// window._rap_ = 'http://api.t.shijieu.cn/'

// if (NODE_ENV === 'production') {
//     window._rap_ = 'https://api.shijieu.cn/';
// } else {
//     window._rap_ = '//api.t.shijieu.cn/';
// }

function checkStatus (response) {
    // var url;
    // var isParents = (isParentPage() || isParentDomain()) ? true : false;
    // if(String(response.data.code) === '302') {
    //         debugger
    //     let user_detail=getLocalData('user_detail');
    //     if(user_detail&&user_detail.outerRedirectUrl){//私有化学校未登录状态的跳转url
    //         console.log(user_detail.outerRedirectUrl);
    //         // debugger
    //         window.location=user_detail.outerRedirectUrl
    //     }
    //     else {
    //         if (false) {
    //             get(response.data.data.xauth_redirect);
    //             // debugger
    //         } else {
    //             window.nexUrl = window.location.pathname;
    //             const xauth_redirect = response.data && response.data.data && response.data.data.xauth_redirect;

    //             if (!xauth_redirect) {//若无重定向地址，返回登录页
    //                 url = isParents ? parentsLoginUrl : studentLoginUrlWithSchoolCode();
    //             } else {
    //                 // if(isParents){
    //                 //     if(xauth_redirect.includes('account')){//家长端注册成功后返回首页
    //                 //         let str1=xauth_redirect.substring(0,xauth_redirect.indexOf('&xauth_redirect='));
    //                 //         url=str1+'&xauth_redirect='+window.location.origin+'/parents/index'+'#/parents/parentslogin'
    //                 //     }
    //                 //     else {
    //                 //         let str1=xauth_redirect.substring(0,xauth_redirect.indexOf('&xauth_redirect='));
    //                 //         let str2=xauth_redirect.substring(xauth_redirect.indexOf('&xauth_signtype='));
    //                 //         url=str1+'&xauth_redirect='+window.location.origin+'/parents'+str2+'#/parents/parentslogin';
    //                 //     }
    //                 // }
    //                 // else {
    //                 //     url=xauth_redirect+'#/student/studentlogin';
    //                 // }

    //                 if(isParents){
    //                     let str1=xauth_redirect.substring(0,xauth_redirect.indexOf('&xauth_redirect='));
    //                     let str2=xauth_redirect.substring(xauth_redirect.indexOf('&xauth_signtype='));
    //                     url=str1+(getUrlParam('schoolCode')?('&schoolCode=' + getUrlParam('schoolCode')):'') + '&xauth_redirect='+window.location.origin+'/parents'+str2+'#/parents/parentslogin';
    //                 }else {
    //                     let str1=xauth_redirect.substring(0,xauth_redirect.indexOf('&xauth_redirect='));
    //                     let str2=xauth_redirect.substring(xauth_redirect.indexOf('&xauth_signtype='));
    //                     url=str1+(getUrlParam('schoolCode')?('&schoolCode=' + getUrlParam('schoolCode')):'')+ '&xauth_redirect='+window.location.origin+window.location.pathname+window.location.search+str2+'#/student/studentlogin';
    //                 }

    //                 // url = xauth_redirect
    //                 //     + (isParents
    //                 //         // ? `${xauth_redirect.indexOf('/parents') > -1 ? '' : '/parents'}#/parents/parentslogin`
    //                 //         ? `#/parents/parentslogin`
    //                 //         : '#/student/studentlogin');
    //             }
    //             window.location = url;
    //             debugger
    //             // url=isParents ? parentsLoginUrl : studentLoginUrl;
    //             // if(!xauth_redirect){
    //             //     window.location = url;
    //             // }else if(window.location.href.includes('direct=welcome')|| xauth_redirect.includes('account')){//天蛙等外接系统注册成功后返回首页 / 家长端注册成功后返回首页
    //             //     window.location = xauth_redirect;
    //             // } else {
    //             //     window.location = url;//家长端/学生端退出后返回各自的登录页
    //             // }
    //         }
    //     }
    // }
    // else if (String(response.data.code) === '403') {
    //     if (isParents) {
    //         const isParentsCookie = response.data.data.user.roles.find(item => item.name === 'parents');
    //         if (!isParentsCookie) {
    //             alert('非家长端账号，请重新登录。');
    //             window.location = parentsLoginUrl;
    //         }
    //     } else {
    //         const isStudentCookie = response.data.data.user.roles.find(item => item.name === 'student');
    //         if (!isStudentCookie) {
    //             alert('非学生端账号，请重新登录。');
    //             window.location = studentLoginUrlWithSchoolCode();
    //         }
    //     }
    // }
    // else if(String(response.data.code)==='401'){
    //     let user_detail=getLocalData('user_detail');
    //     if(user_detail&&user_detail.outerRedirectUrl){//私有化学校未登录状态的跳转url
    //         console.log(user_detail.outerRedirectUrl);
    //         debugger
    //         window.location=user_detail.outerRedirectUrl
    //     }
    //     else {
    //         response.data.data = {};
    //         response.data.data.errMsg = {__all__: [response.data.message]}
    //         return response.data.data || {};
    //     }
    // }
    // else if(String(response.data.code)==='102'){//异步任务提交成功
    //     return response.data||{};
    // }
    // else {
    //     window.nexUrl ='';
    //     if(response.data=='ok'){
    //         return response
    //     }
    //     if (response.data.code !== 200) {
    //         console.error(response.data.message);
    //         if (response.data.code === 404) {
    //             response.data.data = {};
    //             response.data.data.errMsg = {__all__: [response.data.message]};
    //             response.data.data.code = 404;
    //         }
    //         else if (!response.data.data || !response.data.data.errMsg) {
    //             response.data.data = {};
    //             response.data.data.errMsg = {__all__: [response.data.message]}
    //         }
    //     }
    //     // 根据登录接口信息判断跳转到谁的登录页面
    //     if ((response.request.responseURL.indexOf('/accounts/get_detail') > -1) && response.data.code === 200) {
    //         if ((response.data.data.is_login === true)
    //             && isParents
    //             && (response.data.data.role !== 'parents')) {
    //             window.location = parentsLoginUrl;
    //         } else if ((response.data.data.is_login === true)
    //                    && !isParents
    //                    && (response.data.data.role !== 'student')) {
    //             window.location = studentLoginUrlWithSchoolCode();
    //         }
    //         console.log(window.location)
    //         // debugger
    //     }
        return response.data.data || {};
    
}
// 序列化url
function serialize(obj) {
    const result = [];
    for (const k in obj) {
        result.push(encodeURIComponent(k) + '=' + encodeURIComponent(obj[k]));
    }
    return result.join('&');
}
// function dealAegis(){
//     //腾讯云性能上报，返回码错误逻辑优化
//     window.aegis({
//         reportApiSpeed: true, // 需要开两个，不然不会有返回码上报
//         reportAssetSpeed: true,
//         api: {
//             retCodeHandler(data, url, xhr) {
//                 console.log(data);
//                 // data 是string类型，如果需要对象需要手动parse下
//                 // url 为请求url
//                 // xhr 响应,可以通过xhr.response拿到完整的后台响应
//                 try {
//                     data = JSON.parse(data)
//                 } catch(e) {}
//                 return {
//                     // isErr 如果是 true 的话，会上报一条 retcode 异常的日志。
//                     isErr: data.body.code !== 200,
//                     code:  data.body.code
//                 }
//             }
//         }
//     });
// }
function get (url, param={}, use_xauth = true) {
    axios.defaults.baseURL = window._rap_;
    // console.log("here", axios.defaults.baseURL, url);
    axios.defaults.withCredentials = true;
    axios.defaults.headers['Access-Control-Allow-Origin'] = '*';
    axios.defaults.headers.post['Content-Type'] = "application/json";//使用此头部时，需要将post参数进行stringfy
    axios.defaults.timeout = 30 * 1000;
    if (use_xauth) {
        getUrlParam('xauth_ticket') && (param.xauth_ticket = getUrlParam('xauth_ticket'));
    }
    // window.location.href.indexOf('.t.') == -1 && dealAegis();
    return axios.get(url,{params: param}).then(checkStatus).catch(d => d);
}

function post (url,param) {
    axios.defaults.baseURL = window._rap_;
    axios.defaults.withCredentials = true;
    // axios.defaults.headers['Access-Control-Allow-Origin'] = '*';
    axios.defaults.headers.post['Content-Type'] = "application/json";//使用此头部时，需要将post参数进行stringfy
    axios.defaults.timeout=30*1000;
    if (url.indexOf('xauth') > -1) {
        // 过xauth 的要是有form 的形式；
        axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded; charset=UTF-8';
        param = serialize(param);
    }

    getUrlParam('xauth_ticket') && (url = url + "?xauth_ticket" + getUrlParam('xauth_ticket'));
    // debugger
    // window.location.href.indexOf('.t.') == -1 && dealAegis();
    return axios.post(url, param).then(checkStatus);
}

export default {
    get,
    post,
}





// WEBPACK FOOTER //
// ./src/utils/new_request.js